var React = require('react');

function Quotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 34V18.9109L9.4873 0H15.1143L6.93555 18.9109H15.1143V34H0ZM23.8164 34V18.9109L33.3691 0H38.9961L30.8174 18.9109H38.9961V34H23.8164Z","fill":"#BDB4A8"}));
}

Quotes.defaultProps = {"width":"39","height":"34","viewBox":"0 0 39 34","fill":"none"};

module.exports = Quotes;

Quotes.default = Quotes;
